module.exports = __webpack_public_path__ + "media/images/icons/icn_046-07d89f6bd96974baf47f3db0193ad40b.svg";